import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import i18n from '../../i18n/index.js';

// LocaleContext provides current locale (en-US | pt-BR) and a toggle + setter
const LocaleContext = createContext({
  locale: 'en-US',
  setLocale: () => {},
  toggleLocale: () => {},
});

export const LocaleProvider = ({ initialLocale = 'pt-BR', children }) => {
  const [locale, setLocale] = useState(initialLocale);

  // Load persisted locale once
  useEffect(() => {
    const saved = typeof window !== 'undefined' ? window.localStorage.getItem('locale') : null;
    if (saved === 'pt-BR' || saved === 'en-US') setLocale(saved);
  }, []);

  const toggleLocale = useCallback(() => {
    setLocale(l => {
      const next = l === 'pt-BR' ? 'en-US' : 'pt-BR';
      try { window.localStorage.setItem('locale', next); } catch(e) { /* persistence optional */ }
      return next;
    });
  }, []);

  // Sync i18next language when locale changes
  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale).catch(() => {});
    }
  }, [locale]);

  const value = { locale, setLocale, toggleLocale };
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
};

export const useLocale = () => useContext(LocaleContext);
export const useT = () => i18n.t.bind(i18n);

export default LocaleContext;
